<template>
	<div class="improcing layui-layout layui-layout-admin">
		<div class="layui-header zt_color layui-row f_row al_itm jc_ct">
			<div class="px24" style="color:#fff;">完善资料</div>
		</div>
		<div class="layui-form rgBoxs" action="">
			<div class="layui-form-item">
				<label class="layui-form-label requires">企业名称</label>
				<div class="layui-input-block">
					<input type="text" name="names" required lay-reqText="请输入企业名称" lay-verify="required" placeholder="请输入企业名称" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label requires">负责人姓名</label>
				<div class="layui-input-block">
					<input type="text" name="names1" required lay-reqText="请输入负责人姓名" lay-verify="required" placeholder="请输入负责人姓名" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label requires">生产类别</label>
				<div class="layui-input-block">
					<select name="class1" lay-reqText="请选择生产的类别" lay-verify="required">
						<option value="">请选择生产的类别</option>
						<option v-for="(item,index) in class1" :value="index">{{item}}</option>
					</select>
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label requires">印刷机台数</label>
				<div class="layui-input-block">
					<input type="text" name="class2" onkeyup="value=value.replace(/[^\d]/g,'')" lay-verify="" placeholder="请输入印刷机台数" autocomplete="off" class="layui-input">
					<!--<select name="class2" lay-reqText="请选择印刷机台数" lay-verify="required">
						<option value="">请选择印刷机台数</option>
						<option v-for="(item,index) in class2" :value="index">{{item}}</option>
					</select>-->
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label requires">所属区域</label>
				<div class="layui-input-block">
					<select name="class3" lay-reqText="请选择所属区域" lay-verify="required">
						<option value="">请选择所属区域</option>
						<option v-for="(item,index) in class3" :value="index">{{item}}</option>
					</select>
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label requires">是否需要开发票</label>
				<div class="layui-input-block">
					<select name="class4" lay-reqText="请选择是否需要开发票" lay-verify="required">
						<option value="">请选择</option>
						<option v-for="(item,index) in class4" :value="index">{{item}}</option>
					</select>
				</div>
				<p style="color: #E51C23;font-size: 14px;margin-top: 15px;margin-left:110px;">注：如果需要开发票的话，每个订单则要收取订单金额13%的税点。并且订单累计的金额达到10000元才可以开发票。</p>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">推&nbsp;&nbsp;荐&nbsp;&nbsp;人</label>
				<div class="layui-input-block">
					<input type="phone" name="phone" lay-verify="" placeholder="请输入推荐人的手机号码(选填)" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">联系QQ</label>
				<div class="layui-input-block">
					<input type="text" name="qq" lay-verify="" placeholder="请输入您的联系QQ号码(选填)" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label requires">营业执照</label>
				<div class="layui-input-block">
					<button type="button" class="layui-btn zt_color" id="imgs1">
                <i class="layui-icon">&#xe67c;</i><span v-if="img1 == ''">上传图片</span><span v-else>重新上传</span>
              </button>
					<img v-show="img1 != ''" :src="urls + img1" width="400" />
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label"></label>
				<div class="layui-input-block">
					<button class="nextBtns pointer zt_color" lay-submit lay-filter="impros">提交注册</button>
				</div>
			</div>
		</div>
		<div class="layui-footer align_center zt_color f_row al_itm jc_ct" style="left:0;color:#fff;">
			<span>© 桃琼之瑶SMT活动钢网</span>
		</div>
		<div v-show="showOks" class="rgstOk f_col al_itm jc_ct">
			<i class="layui-icon layui-icon-ok-circle zt_txt_color px200"></i>
			<span class="px24">注册成功!</span>
			<span @click="goHomes" class="px16 zt_txt_color d_line pointer">{{times}}S后跳转</span>
		</div>
		<div id="qrCode" style="display: none;">
			<img src="../assets/qrcode.png" />
			<p>亲爱的，请打开手机微信扫描上图二维码，关注我们的公众号并且选择绑定。您将及时收到我们平台给您推送的订单实时信息，桃琼之瑶为您助力。假如您不绑定我们的公众号，给您带来的不便及损失，平台将不承担相关责任。</p>
			<button class="layui-btn zt_color" style="display: block;margin: 20px auto 0;" @click="onClose">已关注</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login',
		data() {
			return {
				forms: '',
				times: 3,
				showOks: false,
				class1: ['通讯设备', '工控集成', '军工集成', '航天航空', '消费类电子', '智能家居', 'AI制造', '计算机周边', '医疗器械', '汽车电子'],
				class2: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
				class3: ['华南', '华北', '华中', '华东', '华西'],
				class4: ['不需要发票', '需要发票'],
				urls: 'https://mr.summary88.com/',
				img1: '',
				img2: ''
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			layui.use(['form', 'layer', 'upload'], () => {
				this.forms = layui.form;
				var layer = layui.layer;
				var upload = layui.upload;
				this.forms.on('submit(impros)', (e) => {
					if(this.img1 == '') {
						layer.msg('请上传营业执照', {
							icon: 2,
							anim: 6
						})
					} else {
						api.fillInfo({
							token: this.getCookie('token'),
							company_name: e.field.names,
							user_name: e.field.names1,
							category_id: this.class1[e.field.class1],
							device_num: this.class2[e.field.class2],
							area_id: this.class3[e.field.class3],
							need_invoice: e.field.class4 == 0 ? 0 : 1,
							referee_mobile: e.field.phone,
							qq: e.field.qq,
							business_license: this.img1,
							id_card_img: ''
						}).then((res) => {
							if(res.code == 1) {
								layer.open({
									title: '',
									type: 1,
									content: $('#qrCode'),
									shade: 0.3,
									resize: false,
									cancel: function(index, layero) {
										_this.showOks = true;
										let jshi = setInterval(() => {
											if(_this.times >= 1) {
												_this.times = _this.times - 1
											} else {
												clearInterval(jshi);
												_this.$router.replace('login');
											}
										}, 1000)
									}
								});
							} else if(res.code == 0) {
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					}
				});
				//执行实例
				this.forms.render();
				var uploadInst1 = upload.render({
					elem: '#imgs1', //绑定元素
					url: ' https://mr.summary88.com/api/Common/upload', //上传接口
					accept: 'images',
					number: 1,
					field: 'file',
					exts: 'jpg|jpeg|png|gif',
					done: function(res) {
						_this.img1 = res.data.url;
					}
				});
				this.forms.render();
			});
		},
		methods: {
			goHomes() {
				this.$router.replace('login');
			},
			onClose() {
				let _this = this;
				this.showOks = true;
				layer.closeAll();
				let jshi = setInterval(() => {
					if(_this.times >= 1) {
						_this.times = _this.times - 1
					} else {
						clearInterval(jshi);
						_this.$router.replace('login');
					}
				}, 1000)
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#qrCode {
		width: 300px;
		padding: 20px;
	}
	
	#qrCode img {
		display: block;
		width: 300px;
		height: 300px;
		margin-bottom: 10px;
	}
	
	#qrCode p {
		font-size: 16px;
		text-align: center;
		color: #FF494C;
	}
	
	.rgstOk {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #fff;
		z-index: 99999;
	}
	
	.requires::before {
		content: url('../assets/require.png');
		width: 20px;
		height: 20px;
		position: absolute;
		top: 50%;
		margin-top: -10px;
		left: -24px;
	}
	
	.rgBoxs {
		width: 40%;
		font-size: 16px;
		margin: 50px auto;
	}
	
	.rgBoxs input {
		width: 100%;
		line-height: 45px;
		height: 45px;
		border-radius: 0px;
		color: rgba(136, 136, 136, 1);
		text-align: left;
		font-family: Microsoft Yahei;
		border: 1px solid rgba(187, 187, 187, 1);
	}
	
	.rgBoxs .nextBtns {
		width: 100%;
		line-height: 40px;
		border-radius: 0px;
		color: rgba(255, 255, 255, 1);
		font-size: 16px;
		text-align: center;
		font-family: SourceHanSansSC;
	}
</style>


// WEBPACK FOOTER //
// src/components/improving.vue